<template>
    <div class="account landing-page">
        <div class="action-header">
            <div class="info">
                <div class="flex-col icon">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;" xml:space="preserve"><g><g><path d="M609.608,315.426c3.19-5.874,3.19-12.979,0-18.853c-58.464-107.643-172.5-180.72-303.607-180.72 S60.857,188.931,2.393,296.573c-3.19,5.874-3.19,12.979,0,18.853C60.858,423.069,174.892,496.147,306,496.147 S551.143,423.069,609.608,315.426z M306,451.855c-80.554,0-145.855-65.302-145.855-145.855S225.446,160.144,306,160.144 S451.856,225.446,451.856,306S386.554,451.855,306,451.855z"/><path d="M306,231.67c-6.136,0-12.095,0.749-17.798,2.15c5.841,6.76,9.383,15.563,9.383,25.198c0,21.3-17.267,38.568-38.568,38.568 c-9.635,0-18.438-3.541-25.198-9.383c-1.401,5.703-2.15,11.662-2.15,17.798c0,41.052,33.279,74.33,74.33,74.33 s74.33-33.279,74.33-74.33S347.052,231.67,306,231.67z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                </div>
                <div class="flex-col main">
                    <span class="title">Last check report</span>
                    <span class="desc">Completed {{completed_at}}</span>
                </div>
                <div class="flex-col minor">
                    <span class="title">{{page_checked}}</span>
                    <span class="desc">pages checked</span>
                </div>
                <div class="flex-col minor">
                    <span class="title red">{{issues}}</span>
                    <span class="desc">issued detected</span>
                </div>
                <div class="flex-col minor">
                    <span class="title green">{{resolved}}</span>
                    <span class="desc">issues resolved</span>
                </div>
            </div>
            <div class="actions flex-col">
                <div v-if="new_data_available" class="new-data-available">
                    New data available
                    <div class="btn btn-primary" @click="getTotalData">UPDATE</div>
                </div>
                <div v-else-if="!new_data_available && newDataAfterMin < 0" class="check-new-data">
                    Waiting new data
                    <div class="loader">
                        <svg class="circular" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"/>
                        </svg>
                    </div>
                </div>
                <div v-else class="check-new-data">
                    Next check in {{newDataAfterMin}} min
                </div>
                <div class="action-group">
                    <span class="action">
                        <data-filter @filterApply='applyFilter' v-bind:filtersInit="filtersDataComponent"></data-filter>
<!--                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 472.615 472.615" style="enable-background:new 0 0 472.615 472.615;" xml:space="preserve"><g><g><polygon points="472.615,12.908 0,12.908 180.081,202.629 180.066,459.708 292.55,401.525 292.534,202.629 		"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>-->
                    </span>
                    <div v-if="showSearch" class="action">
                        <div class="actions__search-container">
                            <input @input="applySearch" @blur="hideSearchField" class="actions__search-input" type="text" v-model="filter.query" placeholder="Search"/>
                            <inline-svg
                                class="actions__search-icon"
                                src="/images/search.svg" aria-label="search">
                            </inline-svg>
                            <inline-svg
                                v-show="filter.query"
                                @click="clearSearch()"
                                class="clear-search"
                                src="/images/clear.svg" aria-label="clear">
                            </inline-svg>
                        </div>
                    </div>
                    <div v-else class="action" @click="showSearchField">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 487.95 487.95" style="enable-background:new 0 0 487.95 487.95;" xml:space="preserve"><g><g><path d="M481.8,453l-140-140.1c27.6-33.1,44.2-75.4,44.2-121.6C386,85.9,299.5,0.2,193.1,0.2S0,86,0,191.4s86.5,191.1,192.9,191.1 c45.2,0,86.8-15.5,119.8-41.4l140.5,140.5c8.2,8.2,20.4,8.2,28.6,0C490,473.4,490,461.2,481.8,453z M41,191.4 c0-82.8,68.2-150.1,151.9-150.1s151.9,67.3,151.9,150.1s-68.2,150.1-151.9,150.1S41,274.1,41,191.4z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                    </div>
                    <span @click="onDownloadExcelClick" class="action">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="1200px" height="1200px" viewBox="0 0 1200 1200" enable-background="new 0 0 1200 1200" xml:space="preserve"><sodipodi:namedview  inkscape:cy="263.71451" inkscape:cx="901.76671" inkscape:zoom="0.37249375" showgrid="false" id="namedview30" guidetolerance="10" gridtolerance="10" objecttolerance="10" borderopacity="1" bordercolor="#666666" pagecolor="#ffffff" inkscape:current-layer="svg2" inkscape:window-maximized="1" inkscape:window-y="24" inkscape:window-height="876" inkscape:window-width="1535" inkscape:pageshadow="2" inkscape:pageopacity="0" inkscape:window-x="65"></sodipodi:namedview><path id="path5755" inkscape:connector-curvature="0" d="M0,1037.516h1200V1200H0V1037.516z M820.785,0h-441.57v496.632H103.233 L600,959.265l496.768-462.633H820.785V0z"/></svg>
                    </span>
                </div>
            </div>
        </div>
        <div class="account__table main-table">
            <table class="main-table__wrapper">
                <thead class="main-table__header">
                    <th class="main-table__header-item">
                        <span id="created_at" @click="sortTable($event, 'url', 'ASC')" class="table-header-sort noselect">
                            <span>
                                URL address
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'status', 'ASC')" class="table-header-sort noselect">
                            <span>
                                Status
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span class="table-header-sort noselect">
                            <span>
                                Response time/Error
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'campaigns_count', 'ASC')" class="table-header-sort noselect">
                            <span>
                                Campaigns
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                </thead>
                <tbody class="main-table__body">
                    <template v-if="isLoading" >
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="100">
                                <div class="loader">
                                    <svg class="circular" viewBox="25 25 50 50">
                                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                                    </svg>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else-if="tableData && tableData.length">
                        <tr v-for="item in tableData" class="main-table__row-container">
                            <td class="main-table__row-item not-pointer-column">
                                <div class="site-url">
                                    <img :src="'https://www.google.com/s2/favicons?domain=' + item.url" :alt="item.url">
                                    <span class="url" v-clipboard:copy="item.url">{{ item.url }}</span>
                                    <a class="site-url-btn" :href="'//'+item.url" target="_blank"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.4456 0.133118H7.9322C7.62601 0.133118 7.37784 0.381288 7.37784 0.687481C7.37784 0.993674 7.62601 1.24184 7.9322 1.24184H10.1073L4.79155 6.55757C4.57504 6.77408 4.57504 7.12506 4.79155 7.34157C4.89983 7.44979 5.04169 7.50393 5.18354 7.50393C5.3254 7.50393 5.46726 7.44979 5.57554 7.34157L10.8913 2.02584V4.20097C10.8913 4.50717 11.1394 4.75534 11.4456 4.75534C11.7518 4.75534 12 4.50717 12 4.20097V0.687543C12 0.381288 11.7518 0.133118 11.4456 0.133118Z" fill="#6F747D"/><path d="M9.1778 4.75531C8.8716 4.75531 8.62343 5.00348 8.62343 5.30967V10.7582H1.10873V3.24349H6.88507C7.19127 3.24349 7.43944 2.99532 7.43944 2.68913C7.43944 2.38294 7.19127 2.13477 6.88507 2.13477H0.554364C0.24817 2.13477 0 2.38294 0 2.68913V11.3126C0 11.6188 0.24817 11.8669 0.554364 11.8669H9.1778C9.48399 11.8669 9.73216 11.6188 9.73216 11.3126V5.30967C9.73216 5.00348 9.48399 4.75531 9.1778 4.75531Z" fill="#6F747D"/></svg></a>
                                    <span class="site-url-btn" @click="() => {openIssueHistoryModal(item.id, item.url)}"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1.75C9.8995 1.75 12.25 4.1005 12.25 7C12.25 9.8995 9.8995 12.25 7 12.25C6.00287 12.25 5.04545 11.971 4.21786 11.4529C3.8808 11.242 3.56861 10.9933 3.28747 10.7121C3.0059 10.4305 2.75692 10.1178 2.54576 9.78008C2.02854 8.95295 1.75 7.99629 1.75 7C1.75 6.84015 1.75716 6.68109 1.7714 6.52316C1.80033 6.2023 2.08389 5.96564 2.40476 5.99457C2.72562 6.02349 2.96228 6.30706 2.93335 6.62792C2.92225 6.75104 2.91667 6.87514 2.91667 7C2.91667 7.77594 3.13288 8.51854 3.53495 9.16152C3.69929 9.42433 3.89317 9.66785 4.11248 9.88718C4.33145 10.1062 4.57455 10.2998 4.83688 10.464C5.48022 10.8668 6.22341 11.0833 7 11.0833C9.25516 11.0833 11.0833 9.25516 11.0833 7C11.0833 4.74484 9.25516 2.91667 7 2.91667C5.90838 2.91667 4.89081 3.34798 4.14047 4.08452L4.957 4.08533C5.27916 4.08533 5.54033 4.34649 5.54033 4.66866C5.54033 4.96781 5.31514 5.21437 5.02503 5.24807L4.957 5.25199H2.62285C2.32369 5.25199 2.07713 5.0268 2.04344 4.73669L2.03951 4.66866V2.33538C2.03951 2.01322 2.30068 1.75205 2.62285 1.75205C2.922 1.75205 3.16856 1.97724 3.20226 2.26735L3.20618 2.33538L3.20593 3.37077C4.18022 2.35175 5.53908 1.75 7 1.75ZM6.5625 4.08333C6.78387 4.08333 6.96702 4.24803 6.996 4.46149L7 4.52083V7H8.3125C8.554 7 8.75 7.196 8.75 7.4375C8.75 7.65887 8.58531 7.84202 8.37184 7.871L8.3125 7.875H6.5625C6.34113 7.875 6.15798 7.71031 6.129 7.49684L6.125 7.4375V4.52083C6.125 4.27933 6.321 4.08333 6.5625 4.08333Z" fill="#6F747D"/></svg></span>
                                </div>
                            </td>
                            <td class="main-table__row-item not-pointer-column">
                                <div :class="{
                                    'status': true,
                                    [getUrlStatusInfo(item.status).class]: true
                                }">
                                    {{getUrlStatusInfo(item.status).name}}
                                </div>
                            </td>
                            <td class="main-table__row-item not-pointer-column">
                                <div class="min-center" v-if="item.status === 1">{{item.response_time}}</div>
                                <div class="min-center" v-else >{{item.http_status_code_client}}</div>
                            </td>
                            <td class="main-table__row-item not-pointer-column clickable" @click="() => {openListOfCampaigns(item.id, item.url)}">
                                <div class="min-center">{{ item.campaigns_count }}</div>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="100">Not found</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="pagination-container">
            <span v-if="pages" class="mr-5">Show rows {{page * 20 - 19}} - {{page == pages ? pages_rows : page * 20}} of {{pages_rows}}</span>
            <paginate v-if="pages"
                      :v-model="page"
                      :page-count="pages"
                      :click-handler="getPage"
                      :prev-text="'Prev'"
                      :next-text="'Next'"
                      :container-class="'pagination mb-0'"
                      :page-class="'page-item'">
            </paginate>
        </div>

        <modal :height="'auto'" :width="'400px'" name="issue-history-modal">
            <div class="informative-modal-2 flex flex-col">
                <div class="header">
                    <div class="title">Issues history overview for</div>
                    <div>
                        <img :src="'https://www.google.com/s2/favicons?domain=' + modalData.url" :alt="modalData.url">
                        <span>{{ modalData.url }}</span>
                    </div>
                </div>
                <div class="body">
                    <template v-if="isModalDataLoading">
                        <div class="loader">
                            <svg class="circular" viewBox="25 25 50 50">
                                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                            </svg>
                        </div>
                    </template>
                    <template v-else>
                        <div class="title"
                             v-if="!modalData.history || modalData.history.length === 0">
                            The URL has no issue history
                        </div>
                        <div v-for="(item, index) in modalData.history"
                             :key="index"
                             class="issue-history-block"
                        >
                            <svg class="error-icon" width="36" height="32" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.6085 27.6393L20.5013 1.47303C19.3894 -0.452899 16.6111 -0.453602 15.4988 1.47303L0.391534 27.6393C-0.72039 29.5652 0.668144 31.9717 2.89284 31.9717H33.1072C35.3311 31.9718 36.7208 29.566 35.6085 27.6393ZM19.3234 25.0728C19.3234 25.8036 18.7309 26.3961 18.0001 26.3961C17.2692 26.3961 16.6767 25.8036 16.6767 25.0728V24.2825C16.6767 23.5517 17.2692 22.9592 18.0001 22.9592C18.7309 22.9592 19.3234 23.5517 19.3234 24.2825V25.0728ZM19.3234 19.9166C19.3234 20.6474 18.7309 21.24 18.0001 21.24C17.2692 21.24 16.6767 20.6474 16.6767 19.9166V12.3306C16.6767 11.5997 17.2692 11.0072 18.0001 11.0072C18.7309 11.0072 19.3234 11.5997 19.3234 12.3306V19.9166Z" fill="#DC4B3E"/></svg>
                            <div class="error-info">
                                <div class="error-title">{{item.http_status_code_client}} error</div>
                                <div>Detected on: {{item.created_at}}</div>
                                <div>Resolved on: <span :class="{'error': item.resolved_at}">{{item.resolved_at ? item.resolved_at : 'Not resolved'}}</span></div>
                                <div>Down for: {{item.down_for}}</div>
                            </div>
                            <div class="error-ago">{{item.time_ago}} ago</div>
                        </div>
                    </template>
                </div>
                <div class="footer flex justify-end space-x-2">
                    <template v-if="modalData.additionalIssues > 0 && !isModalDataLoading">
                        <a class="like-link" :href="'/landing-pages/issues-history?id='+modalData.url_id">View
                            {{ modalData.additionalIssues }} more issues in the full Issues history</a>
                    </template>
                </div>
            </div>
        </modal>
        <modal :height="'auto'" :width="'400px'" name="wait-download-modal" :clickToClose="false">
            <div class="informative-modal flex flex-col">
                <div class="header">

                </div>
                <div class="body">
                    <div class="loader mb-3">
                        <svg class="circular" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                        </svg>
                    </div>
                    Processing your file. Please wait a few moments.
                </div>
                <div class="footer flex justify-end space-x-2">

                </div>
            </div>
        </modal>
        <modal :height="'auto'" :width="'400px'" name="background-download-modal" :clickToClose="false">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Background Export Report
                </div>
                <div class="body">
                    You have over 10,000 records in your report based on the applied filters. We run large reports in the background so you can continue working in PPC Shield without having to wait for them to download. When the file is ready, you will receive an email with a link to download it.
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="$modal.hide('background-download-modal')">Close</button>
                </div>
            </div>
        </modal>
        <modal :height="'auto'" :width="'400px'" name="error-too-large-modal" :clickToClose="false">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    File is too large
                </div>
                <div class="body">
                    You have over 100,000 rows in your report based on the applied filters and date range. You can export only up to 100,000 rows. Please try to reduce the date range or apply some filter.
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="$modal.hide('error-too-large-modal')">Close</button>
                </div>
            </div>
        </modal>
        <modal :height="'auto'" :width="'470px'" name="active-campaigns-modal" :scrollable="true">
            <div class="informative-modal-2 flex flex-col">
                <div class="header">
                    <div class="title">You have {{modalData.total}} active campaigns for</div>
                    <div>
                        <img :src="'https://www.google.com/s2/favicons?domain=' + modalData.url" :alt="modalData.url">
                        <span>{{ modalData.url }}</span>
                    </div>
                </div>
                <div class="body">
                    <template v-if="isModalDataLoading">
                        <div class="loader">
                            <svg class="circular" viewBox="25 25 50 50">
                                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                            </svg>
                        </div>
                    </template>
                    <template v-else>
                        <div class="title"
                             v-if="!modalData.campaigns || modalData.campaigns.length === 0">
                            The URL has no campaigns
                        </div>
                        <div v-for="(item, index) in modalData.campaigns"
                             :key="index"
                             class="campaign-block"
                        >
                            {{item.name}}
                        </div>
                    </template>
                </div>
                <div class="footer flex justify-end space-x-2"></div>
            </div>
        </modal>
    </div>
</template>

<script>
import {lastCheckTable} from '../../helpers/LandingPage/last-check-table';
import Paginate from 'vuejs-paginate';
import {dateShortCuts, defaultDateRange, setCookiesDateRange, dateToString, stringToDate} from "../../helpers/date-converter";

export default {
    name: 'last-check',
    props: [],
    components: {
        Paginate
    },
    data: function () {
        return {
            isLoading: false,

            isModalDataLoading: false,
            modalData: {},

            newDataInterval: null,
            newDataAfterMin: null,
            new_data_available: false,

            tableData: null,
            page_checked: 0,
            issues: 0,
            resolved: 0,
            completed_at: '',
            pages_rows: null,
            pages: null,
            page: 1,
            filter: {
                query: '',
                page: 1,
                tags: {},
                campaign_id: 'null',
                sort: {
                    'column': '',
                    'sort': '',
                }
            },
            time: defaultDateRange(),
            shortcuts: dateShortCuts(),
            filtersDataComponent: null,
            disabledAfter: this.$moment(moment().add(1, 'day').format("DD-MM-YYYY"), "DD-MM-YYYY"),
            crutch_for_date_picker: false,
            isLoadingFilter: false,
            showSearch: false,
        }
    },
    computed: {
        customFormat() {
            return {
                stringify: (date) => {
                    if(moment(this.time[1]).format('L') === moment(this.time[0]).format('L')){
                        if(!this.crutch_for_date_picker){
                            this.crutch_for_date_picker = true;
                        }
                        else  {
                            this.crutch_for_date_picker = false;
                        }
                        return date
                            ? this.crutch_for_date_picker
                                ? moment(date).format('L') === moment(this.time[0]).format('L')
                                    ? dateToString(moment(this.time[0]).format('MMM D YYYY'), moment(this.time[1]).format('MMM D YYYY'))
                                    : ''
                                : ''
                            : ''
                    }
                    else{
                        return date
                            ? moment(date).format('L') === moment(this.time[0]).format('L')
                                ? dateToString(moment(this.time[0]).format('MMM D YYYY'), moment(this.time[1]).format('MMM D YYYY'))
                                : ''
                            : ''
                    }
                },
                parse: (value) => {
                    return value
                        ? this.calcDateFormatToDate()
                        : null
                },
            }
        },
    },
    methods: {

        openListOfCampaigns(id, url){
            this.modalData = {
                url
            }
            this.getListOfCampaigns(id);
            this.$modal.show('active-campaigns-modal');
        },
        getListOfCampaigns(id){
            this.isModalDataLoading = true;
            axios.post('/landing-pages/dashboard/getUrlCampaigns', {id})
                .then((res) => {
                    this.modalData = res.data;
                }).finally(() => {
                this.isModalDataLoading = false;
            });
        },
        hideSearchField(){
            setTimeout(() => {
                this.showSearch = false;
            }, 500);
        },
        showSearchField(){
            this.showSearch = true;
            setTimeout(() => {
                $('.actions__search-input').focus();
            },0);
        },
        openIssueHistoryModal(id, url){
            this.modalData.url = url;
            this.getUrlHistory(id);
            this.$modal.show('issue-history-modal');
        },
        getUrlHistory(id){
            this.isModalDataLoading = true;
            axios.post('/landing-pages/issues-history/getUrlHistory', {id})
                .then((res) => {
                    this.modalData = res.data;
                }).finally(() => {
                    this.isModalDataLoading = false;
                });
        },
        checkNewData(){
            axios.post('/landing-pages/last-check/hasNewData', {
                job_id: this.tableData[0].job_id,
            }).then((res) => {
                this.new_data_available = res.data.new_data_available;
                if(res.data.new_data_available){
                    clearInterval(this.newDataInterval);
                    this.newDataInterval = null;
                }
            });
        },
        getUrlStatusInfo(status){
            switch (status){
                case 1: return {'class': 'green', 'name': 'Live page'};
                case 2: return {'class': 'red', 'name': 'Issue'};
                case 3: return {'class': 'light-green', 'name': 'Resolved'};
                default: return {'class': '', 'name': 'Unknown'};
            }
        },
        onDownloadExcelClick(){
            if(this.isLoading || !this.pages_rows) return;
            if(this.pages_rows > 100000){
                this.$modal.show('error-too-large-modal');
                return;
            }

            const date_from = this.time[0] ? moment(this.time[0]).format('DD-MM-YYYY') : '';
            const date_to = this.time[1] ? moment(this.time[1]).format('DD-MM-YYYY') : '';
            if(this.pages_rows < 10000){
                this.$modal.show('wait-download-modal');

                axios.get('/download/excelReport?query=' + this.filter.query
                    + '&column=' + this.filter.sort.column
                    + '&type=' + this.filter.sort.type
                    + '&filters=' + JSON.stringify(this.filter.tags)
                    + '&date_from=' + date_from
                    + '&date_to=' + date_to
                    + '&excelFor=last-check'
                )
                    .then(info => {
                        this.$modal.hide('wait-download-modal');
                        console.log(info.data.download_url);
                        const a = document.createElement("a");
                        a.href =  info.data.download_url;
                        a.setAttribute("download", 'file');
                        a.click();
                    })
                    .catch(err => {
                        console.log('err', err);
                        this.$modal.hide('wait-download-modal');
                    });
            }
            else{
                axios.get('/download/excelReport?query=' + this.filter.query
                    + '&column=' + this.filter.sort.column
                    + '&type=' + this.filter.sort.type
                    + '&filters=' + JSON.stringify(this.filter.tags)
                    + '&date_from=' + date_from
                    + '&date_to=' + date_to
                    + '&excelFor=last-check'
                    + '&task=' + 'true'
                )
                    .then(info => {
                        this.$modal.show('background-download-modal');
                    })
                    .catch(err => {
                        console.log('err', err);
                        this.$modal.show('background-download-modal');
                    });
            }
        },
        onLoadFilterData(){
            if(this.isLoadingFilter || this.filtersDataComponent) return;
            this.getFiltersData();
        },
        calcDateFormatToDate(){
            let stringDate = $('.action-header__date-picker .mx-input-wrapper input').val();
            let tempTime = stringToDate(stringDate);
            if(tempTime[0].isValid() &&
                tempTime[1].isValid() &&
                (moment(this.time[0]).format('MMM D YYYY') !== moment(tempTime[0]).format('MMM D YYYY') ||
                    moment(this.time[1]).format('MMM D YYYY') !== moment(tempTime[1]).format('MMM D YYYY')))
            {
                this.time = [tempTime[0].toDate(), tempTime[1].toDate()];
                this.getChartData();
            }
            return null;
        },
        sortTable(event, column, type) {
            $(".sort-icon").removeClass("active-sort");
            let element = $(event.currentTarget);
            if(column === this.filter.sort.column) {
                if(this.filter.sort.type === 'ASC') {
                    type = 'DESC';
                    $(element).find(".sort-icon-asc").addClass("active-sort");
                }
                /*else if(this.filter.sort.type === 'DESC') {
                    type = '';
                }*/
                else {
                    type = 'ASC';
                    $(element).find(".sort-icon-desc").addClass("active-sort");
                }
            } else {
                $(element).find(".sort-icon-desc").addClass("active-sort");
            }
            this.filter.sort.column = column;
            if(type === '') this.filter.sort.column = '';
            this.filter.sort.type = type;
            this.getTotalData();
        },
        clearSearch() {
            this.filter.query = '';
            this.getTotalData();
        },
        getTotalData() {
            const last_search_value = this.filter.query;
            if(this.isLoading) return;
            this.isLoading = true;
            this.filter.campaign_id = this.campaign_id;
            console.log( this.filter.tags)
            axios.post('/landing-pages/last-check/total', {
                query: this.filter.query,
                page: this.filter.page,
                campaign_id: this.filter.campaign_id,
                column: this.filter.sort.column,
                type: this.filter.sort.type,
                date_from: this.time[0] ? moment(this.time[0]).format() : '',
                date_to: this.time[1] ? moment(this.time[1]).format() : '',
                //timezone: new Date().getTimezoneOffset(),
                filters: this.filter.tags
            })
            .then(info => {
                this.isLoading = false;
                if(last_search_value === this.filter.query){
                    const {data: {items = []}} = info;
                    this.tableData = lastCheckTable(items);
                    this.pages_rows = info.data.total_rows;
                    this.pages = info.data.total;
                    this.page_checked = info.data.page_checked;
                    this.issues = info.data.issues;
                    this.resolved = info.data.resolved;
                    this.completed_at = info.data.completed_at;
                    this.setIntervalNewData(info.data.next_check_in);
                    setTimeout(() => {
                        $(function () {
                            $('[data-toggle="tooltip"]').tooltip()
                        })
                    },0);
                }
                else{
                    this.getTotalData();
                }
            })
            .catch(err => {
                this.isLoading = false;
                console.log('err', err);
            });
        },
        setIntervalNewData(minutes){
            this.newDataAfterMin = minutes;
            this.new_data_available = false;

            if(this.newDataAfterMin <= 0){
                this.newDataInterval = setInterval(() => {
                    this.checkNewData();
                }, 1000*30);
                this.checkNewData();
            }
            else{
                this.newDataInterval = setInterval(() => {
                    this.newDataAfterMin--;
                    if(this.newDataAfterMin < 0){
                        clearInterval(this.newDataInterval);
                        this.newDataInterval = setInterval(() => {
                            this.checkNewData();
                        }, 1000*30);
                        this.checkNewData();
                    }
                }, 1000*60);
            }
        },
        getFiltersData() {
            this.isLoadingFilter = true;
            axios.post('/landing-pages/last-check/totalled')
                .then(info => {
                    this.filtersDataComponent = info.data.items;
                })
                .catch(err => {
                    console.log('err', err);
                }).finally(() => {
                    this.isLoadingFilter = false;
                });
        },
        applySearch() {
            this.page = 1;
            this.filter.page = 1;
            this.getTotalData();
        },
        applyFilter(data) {
            this.filter.tags = data.filter_data;
            this.page = 1;
            this.filter.page = 1;
            this.getTotalData();
        },
        getPage: function (pageNum) {
            this.page = pageNum;
            this.filter.page = pageNum;
            this.getTotalData()
        },
        setAllTimeDatePicker(){
            axios.get('/account/getStartAllTimeDate')
                .then(response => {
                    this.shortcuts = dateShortCuts(response.data);
                });
        },
    },
    mounted() {
        this.setAllTimeDatePicker();

        setTimeout(() => {$('#created_at').find(".sort-icon-asc").addClass("active-sort");}, 200);
        this.filter.sort.column = 'created_at';
        this.filter.sort.type = 'DESC';
        this.getFiltersData();
        this.getTotalData();
    },
    watch: {
        time: function(val) {
            setCookiesDateRange(val[0], val[1]);
            this.getTotalData();
        }
    }
}
</script>
